export default __webpack_public_path__ + "static/media/6.68d6f89c.jpg";